export default __webpack_public_path__ + "static/media/glyph_up_green_icon.8cc319d9.svg";